/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Tour } from '../../models/tour';

export interface GetScheduledTour$Params {

/**
 * Id of a resource.
 */
  id: string;
}

export function getScheduledTour(http: HttpClient, rootUrl: string, params: GetScheduledTour$Params, context?: HttpContext): Observable<StrictHttpResponse<Tour>> {
  const rb = new RequestBuilder(rootUrl, getScheduledTour.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Tour>;
    })
  );
}

getScheduledTour.PATH = '/api/v1/tours/scheduled/{id}';
